import React from "react";
import { useParams } from "react-router-dom";

const RosterWeekView = () => {
  const { week } = useParams();
  return <div>week: {week}</div>;
};

export default RosterWeekView;
